import { Skeleton, SkeletonItem, TableBody, TableCell, TableHeader, TableRow } from '@fluentui/react-components';
import type { Table } from '@tanstack/react-table';
import { Fragment } from 'react/jsx-runtime';
import type { ContextModel } from '../../hooks/_shared/context.js';
import { ResizableTableCellBlank } from '../cell-blank/index.js';
import { ResizableTableDividerBottom } from '../divider-bottom/index.js';
import { ResizableTable } from '../table/index.js';
import { useStyles } from './styles.js';

type ResizableTableLoadingProps<TData> = {
    context: ContextModel<TData>;
    table: Table<TData>;
    FixedHeaderContent: () => JSX.Element;
};

export function ResizableTableLoading<TData>({
    context,
    table,
    FixedHeaderContent,
}: ResizableTableLoadingProps<TData>) {
    const styles = useStyles();

    const headerGroups = table.getHeaderGroups();

    const padContainerValue = context.padContainerValue;

    return (
        <div className={styles.container}>
            <ResizableTable context={context}>
                <TableHeader>
                    <FixedHeaderContent />
                </TableHeader>

                <TableBody>
                    {Array.from({ length: 8 }).map((_) => {
                        return headerGroups.map((headerGroup, headerGroupIndex) => (
                            <Fragment key={headerGroup.id}>
                                <TableRow
                                    className={styles.row}
                                    // TODO: Fix typing
                                    // @ts-ignore
                                    context={context}
                                >
                                    {headerGroup.headers.map((header, headerIndex) => {
                                        const isFirstColumn = headerGroupIndex === 0 && headerIndex === 0;
                                        const isLastColumn =
                                            headerGroupIndex === headerGroups.length - 1 &&
                                            headerIndex === headerGroup.headers.length - 1;

                                        return (
                                            <Fragment key={header.id}>
                                                {isFirstColumn && padContainerValue && (
                                                    <ResizableTableCellBlank size={padContainerValue} />
                                                )}

                                                <TableCell>
                                                    <Skeleton>
                                                        <SkeletonItem />
                                                    </Skeleton>
                                                </TableCell>

                                                {isLastColumn && padContainerValue && (
                                                    <ResizableTableCellBlank size={padContainerValue} />
                                                )}
                                            </Fragment>
                                        );
                                    })}
                                </TableRow>

                                {padContainerValue && <ResizableTableDividerBottom size={padContainerValue} />}
                            </Fragment>
                        ));
                    })}
                </TableBody>
            </ResizableTable>
        </div>
    );
}
